import React, { useEffect } from 'react';
import './Contact.css';

const Contact = () => {
  useEffect(() => {
    // Add class to App for styling
    const appElement = document.querySelector('.App');
    if (appElement) {
      appElement.classList.add('contact-page-active');
    }
    
    // Function to handle scroll based on screen size
    const handleResize = () => {
      const isLargeScreen = window.innerWidth >= 992 && window.innerHeight >= 800;
      if (isLargeScreen) {
        // Disable scroll on large screens
        document.body.style.overflow = 'hidden';
        document.documentElement.style.overflow = 'hidden';
      } else {
        // Enable scroll on smaller screens
        document.body.style.overflow = '';
        document.documentElement.style.overflow = '';
      }
    };
    
    // Check on mount
    handleResize();
    
    // Listen for resize events
    window.addEventListener('resize', handleResize);
    
    return () => {
      // Restore scroll when leaving page
      document.body.style.overflow = '';
      document.documentElement.style.overflow = '';
      
      // Remove class from App
      if (appElement) {
        appElement.classList.remove('contact-page-active');
      }
      
      // Remove event listener
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <div className="contact-page">
      <div className="container-fluid">
        <div className="contact-text-section">
          <div className="container contact-text-container">
            <p className="lead text-white mb-0 contact-hero-text">
              <span className="contact-hero-line">
                Have an idea, a challenge, or a project in mind?&nbsp; Share a few details about what you're working on,
              </span>
              <span className="contact-hero-line contact-hero-line-secondary">
                &nbsp;&nbsp;and we'll follow up with clear next steps and a thoughtful response.
              </span>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;

